// extracted by mini-css-extract-plugin
module.exports = {"content":"recaptcha_v2_modal_content___Kvty","recaptchaContainer":"recaptcha_v2_modal_recaptchaContainer__uQUbe"};